// extracted by mini-css-extract-plugin
export default {"container":"sectionHeader_container__+jMJH","sectionTitle":"sectionHeader_sectionTitle__t6Gi+","title":"sectionHeader_title__FnLHL","description":"sectionHeader_description__HV3qf"};